// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2qeB0","selected":"Chip_selected__3SjsZ"};